import MoveIcon from '@svgIcons/move.svg';
import CloseIcon from '@svgIcons/close.svg';

import * as C from '../../options/styles';
import { DIRECTIVE_CLAMP } from '@/styles/common.styled';

export default {
    name: 'Chip',
    props: {
        title: {
            type: String,
            required: true,
        },
        status: {
            type: String,
            default: C.ITEM_STATUS.NORMAL,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        dragCursor: {
            type: String,
            default: undefined,
        },
        sortable: {
            type: Boolean,
            default: false,
        },
        removable: {
            type: Boolean,
            default: false,
        },
    },
    render() {
        const { title, status, loading, sortable, removable, dragCursor } =
            this;

        return (
            <C.StatusItemBox
                width={'fit-content'}
                onClick={(e) => {
                    e.stopPropagation();
                }}
                dragCursor={dragCursor}
                status={status}
                loading={loading}
            >
                {sortable && <MoveIcon class="move" v-view-box />}
                <div class="text-wrapper">
                    <div class="item-text" {...DIRECTIVE_CLAMP}>
                        {title}
                    </div>
                    {removable && (
                        <CloseIcon
                            class="close"
                            v-view-box
                            onClick={() => {
                                this.$emit('remove');
                            }}
                        />
                    )}
                </div>
            </C.StatusItemBox>
        );
    },
};
